<template>
  <div>

    <modal
      :title="$t('Zone.modal.delivery_order.title')"
      @close-request="reinitializeModal();"
      closable
      >

      <table-element
      :title="$t('Zone.modal.delivery_order.table_title')"
      :fields="fieldsObj"
      :arrOfElement="arrOfOrder"
      :sortSpacing="3"
      :isShowFilter="false"
      class="card mx-2 mt-4"
      :driversSort="true"
      :isDraggable="true"
      @updateFinalData="updateFinalData"
      >

        <template #pre-body-content>
          <regular-datalist-driver
            key="driver"
            :value="driverName"
            :disabled="true"
            :placeholder="$t('OrderInfo.modal.driver') + '*'" class="form-group border m-2"/>
        </template>

        <template #body-content-desktop="content">
          <!-- List of orders -->
          <tr v-for="(order, index) in content.results"
          class="table-element_hover text-center draggable-item"
          :id="'order' + index"
          :key="order.orderNumber">
          <td><i class="mx-2 fa fa-solid fa-bars drag-handle" /></td>
          <td></td>
            <td></td>
            <td v-if="isOrderNbClickable">
              <strong >
                <router-link :to="{
                  name: 'OrderInfo',
                  query: {orderId: order.orderNumber}}"
                  target="_blank">
                  {{order.orderNumber}}
                </router-link>
              </strong>
            </td>
            <td v-else>
              {{order.orderNumber}}
            </td>
            <td  style="width: 20%;">
              {{ order.deliveryType ? order.deliveryType.toUpperCase() : '' }}
            </td>
            <td  style="width: 40%;">
              <span class="nowrap table-fix-width">{{shortenString($realName(order, 'transmitter'))}}
                <hover-tool-tip
                  :text="`${order.transmitterAddress}
                          ${order.transmitterCity},
                          ${order.transmitterProvince}
                          ${order.transmitterPostcode},
                          ${order.transmitterCountry}`"
                  :top="true"
                  :right="true"
                  :clickable="true"
                />
              </span>
            </td>
            <td  style="width: 40%;">
              <span class="nowrap table-fix-width">{{shortenString($realName(order, 'receiver'))}}
                <hover-tool-tip
                  :text="`${order.receiverAddress}
                          ${order.receiverCity},
                          ${order.receiverProvince}
                          ${order.receiverPostcode},
                          ${order.receiverCountry}`"
                  :top="true"
                  :left="true"
                  clickable
                />
              </span>
            </td>
          </tr>
        </template>

        <template #body-content-mobile="content">
          <!-- List of orders -->
          <div v-for="(order, index) in content.results"
          class="card my-3 mx-2 draggable-item"
          :key="order.orderNumber">
            <div class="card-header">
            <h4 v-if="isOrderNbClickable">
              <strong >
                <router-link :to="{
                  name: 'OrderInfo',
                  query: {orderId: order.orderNumber}}"
                  target="_blank">
                  {{order.orderNumber}}
                </router-link>
              </strong>
            </h4>
            <h4 v-else>
              {{order.orderNumber}}
            </h4>
            </div>

            <div>
              <p class="m-2">
                <span class="nowrap table-fix-width">{{shortenString($realName(order, 'transmitter'))}}
                  <hover-tool-tip
                    :text="`${order.transmitterAddress}
                            ${order.transmitterCity},
                            ${order.transmitterProvince}
                            ${order.transmitterPostcode},
                            ${order.transmitterCountry}`"
                    :top="true"
                    :right="true"
                    :clickable="true"
                  />
                </span>
              </p>
              <p class="m-2">
                <span class="nowrap table-fix-width">{{shortenString($realName(order, 'receiver'))}}
                  <hover-tool-tip
                    :text="`${order.receiverAddress}
                            ${order.receiverCity},
                            ${order.receiverProvince}
                            ${order.receiverPostcode},
                            ${order.receiverCountry}`"
                    :top="true"
                    :left="true"
                    clickable
                  />
                </span>
              </p>
              <p class="m-2">
              </p>
              <p class="m-2">
              </p>
              <p class="m-2">
              </p>
              <div class="d-flex justify-content-center my-3">
                <i class="mx-2 fa fa-solid fa-bars drag-handle" />
              </div>
            </div>
          </div>
        </template>

        <template #post-body-content>
          <div class="mt-2">
            <button
              class="float-right btn btn-kne-orange m-1"
              @click="onReorderConfirm()">
              {{$t('OrderCurrent.modal.confirm')}}
            </button>
            <button @click="reinitializeModal()" class="float-right btn btn-danger m-1">{{$t('OrderCurrent.modal.cancel')}}</button>
          </div>
        </template>
      </table-element>

      <loading-render v-if="isLoading" />
    </modal>

  </div>
</template>

<script>
import Modal from '../../interface-components/Modal.vue'
import regularDatalistDriver from '../../basic-components/regularDatalistDriver.vue'
import hoverToolTip from '../../basic-components/hoverToolTip.vue'
import TableElement from '../Table-component/Table-Element.vue'
import LoadingRender from '../Other-components/LoadingRender.vue'
import { db } from '../../../../firebase'
import { publishOrderSyncRequest } from '../../../../odoo-sync-requests/order'

export default {
  name: 'ShortDispatchModal',
  components: {
    Modal,
    regularDatalistDriver,
    hoverToolTip,
    TableElement,
    LoadingRender
  },

  props: {
    driverName: {
      type: String,
      required: true
    },
    arrOfOrder: {
      type: Array,
      required: true
    },
    isOrderNbClickable: {
      type: Boolean,
      required: false
    },
    isOpen: Boolean
  },

  data () {
    return {
      // Keep a copy of the initial data passed to the child. This will be updated in child component using updateFinalData()
      finalData: this.arrOfOrder.slice().reverse(),
      dispatchOrder: {
        chauffeurUid: '',
        chauffeurName: ''
      },
      fieldsObj: [
       {
         text: this.$t('OrderCurrent.order'),
         type: 'orderNumber',
         value: ''
       },
       {
        text: this.$t('OrderInfo.modal.deliveryType'),
        type: 'deliveryType',
        value: ''
       },
       {
         text: this.$t('OrderInfo.modal.pickup.title'),
         type: 'transmitterName',
         value: ''
       },
       {
         text: this.$t('OrderInfo.modal.delivery.title'),
         type: 'receiverName',
         value: ''
       }
      ],
      selectedDeliveryType: '',
      isLoading: false
    }
  },

  methods: {
    updateFinalData (newData) {
      this.finalData = [...newData]
    },

    async onReorderConfirm () {
      for (const [index, order] of this.finalData.entries()) {
        const keys = order && order.historySync ? Object.keys(order.historySync) : []
        if (!keys.length) continue
        const lastKey = keys[keys.length - 1]
        const firebasePath = db.ref('database').child(`transporter/${this.companyUID}/history/${order.orderNumber}/${lastKey}/deliveryOrder`)
        await this.$store.dispatch('newLog', {'UID': this.uid, 'orderID': order.orderNumber, 'action': 'CHANGE_DELIVERY_ORDER', 'order': order.deliveryOrder, 'date': Date.now()})
        await this.updateOrderFirebase(firebasePath, index + 1)
        publishOrderSyncRequest(order.orderNumber, this.companyUID)
      }
      this.$emit('closeModal')
    },

    updateOrderFirebase (firebasePath, selectedStatus) {
      firebasePath.set(selectedStatus)
    },

    shortenString (text) {
      if (typeof text === 'undefined') return text
      let subString = text.substring(0, 22)
      if (text.length > 22) subString += '...'
      return subString
    },

    reinitializeModal () {
      this.dispatchOrder.chauffeurUid = ''
      this.dispatchOrder.chauffeurName = ''

      this.closeModal()
    },

    clearSelected () {
      this.$emit('clearSelected')
    },

    closeModal () {
      this.$emit('closeModal')
    }
  },
  computed: {
    companyUID () {
      return this.$store.state.authorization.company
    },

    uid () {
      return this.$store.state.user.uid
    }
  }
}
</script>
